import { generateHeader, POSTAPI } from "src/api-setup/api-helper";
import { BULK_INSERT_TIMESHEET } from "src/api-setup/api-endpoints";
import { API_CONSTANTS } from "../../providerPayRequestDashboard/utils/constants";

/*
 * Creates every selected date in one call.
 *
 * The endpoint reports per-row outcomes, so a call can partially succeed
 * (out_ret_code 3, or any mix of succeeded and failed rows). The caller needs
 * the counts and the created keys — the keys are what attachments get bound to —
 * so this returns a structured result rather than a boolean.
 */
export const createBulkPayRequest = async (cookiesData, dispatch, payload) => {
  if (!cookiesData) {
    return { status: false, successCount: 0, failureCount: 0, timesheetKeys: [], message: "Not authenticated" };
  }

  const requestedCount = payload?.in_timesheets_json?.length ?? 0;

  try {
    const apiHeaders = generateHeader();
    const response = await POSTAPI(false, BULK_INSERT_TIMESHEET, null, apiHeaders, payload, dispatch);

    const outParams = response?.data?.out_parameters ?? {};
    const retCode = outParams.out_ret_code;

    const timesheetKeys =
      outParams.success_timesheet_mstr_keys ||
      (response?.data?.row_result?.[0]?.out_timesheet_mstr_key
        ? [response.data.row_result[0].out_timesheet_mstr_key]
        : []);

    const successCount = outParams.out_success_count ?? timesheetKeys.length;
    const failureCount = outParams.out_failure_count ?? Math.max(0, requestedCount - successCount);

    const allSucceeded = retCode === API_CONSTANTS.SUCCESS_CODE && failureCount === 0 && successCount > 0;

    return {
      status: allSucceeded,
      partial: successCount > 0 && failureCount > 0,
      successCount,
      failureCount,
      timesheetKeys,
      message: outParams.out_error_msg || response?.msg || response?.data?.msg || "",
      failedRows: outParams.failed_rows ?? [],
    };
  } catch (error) {
    console.error("Error creating bulk pay request:", error);
    return {
      status: false,
      partial: false,
      successCount: 0,
      failureCount: requestedCount,
      timesheetKeys: [],
      message: error?.message || "Unable to reach the server",
    };
  }
};
